import { useMemo } from "react";

/**
 * Pure-CSS confetti burst, absolutely positioned and clipped to its parent card.
 * No dependencies, no canvas - just a handful of animated shards.
 */
export function Confetti({ pieces = 26 }: { pieces?: number }) {
  const shards = useMemo(
    () =>
      Array.from({ length: pieces }, (_, i) => ({
        left: Math.round((i / pieces) * 100 + (Math.random() * 6 - 3)),
        delay: Math.random() * 0.35,
        duration: 1.5 + Math.random() * 0.9,
        rotate: Math.round(Math.random() * 360),
        size: 5 + Math.round(Math.random() * 5),
        tone: i % 3,
      })),
    [pieces],
  );

  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-0 overflow-hidden"
      style={{ contain: "paint" }}
    >
      {shards.map((s, i) => (
        <span
          key={i}
          className={
            s.tone === 0
              ? "absolute top-0 bg-primary"
              : s.tone === 1
                ? "absolute top-0 bg-foreground/70"
                : "absolute top-0 bg-primary/50"
          }
          style={{
            left: `${s.left}%`,
            width: s.size,
            height: s.size * 1.6,
            borderRadius: 1,
            transform: `rotate(${s.rotate}deg)`,
            animation: `sa-confetti-fall ${s.duration}s cubic-bezier(0.25,0.6,0.35,1) ${s.delay}s forwards`,
          }}
        />
      ))}
      <style>{`
        @keyframes sa-confetti-fall {
          0% { opacity: 0; transform: translateY(-12%) rotate(0deg); }
          10% { opacity: 1; }
          100% { opacity: 0; transform: translateY(520%) rotate(540deg); }
        }
      `}</style>
    </div>
  );
}
